type Matomo = {
    getCustomVariable(id: number, label?: string): string | null;
    getCustomDimension(id: number): string | null;
    getVisitorId(): string | null;
    isUserOptedOut(): boolean;
};

export const sendMatomoEvent = (category: string, action: string, name?: string | null, value?: number | null) => {
    const data: any[] = ['trackEvent', category, action];
    if (name != null) data.push(name);
    if (value != null) {
        if (data.length == 3) data.push(null);
        data.push(value);
    }
    (window as any)._paq?.push(data);
}

export const sendMatomoSearch = (keyword: string, category: string | false, results: number | false) => {
    (window as any)._paq?.push(['trackSiteSearch', keyword, category, results]);
    sendMatomoEvent('Search', 'Value introduced into search input');
}

export const executeMatomoScript = <T>(lambda: (matomo: Matomo) => T): T | null => {
    let result: T | null = null;
    (window as any)._paq?.push([function (this: Matomo) { result = lambda(this); }]);
    return result;
}

export const setMatomoCustomDimension = (id: number, value: string) => {
    (window as any)._paq?.push(['setCustomDimension', id, value]);
}

export const deleteMatomoCustomDimension = (id: number) => {
    (window as any)._paq?.push(['deleteCustomDimension', id]);
}

export const getMatomoCustomDimension = (id: number): string | null => {
    return executeMatomoScript(mtm => mtm.getCustomDimension(id));
}